import { render, staticRenderFns } from "./QuickStart.vue?vue&type=template&id=4c55cc4f&scoped=true&"
import script from "./QuickStart.vue?vue&type=script&lang=js&"
export * from "./QuickStart.vue?vue&type=script&lang=js&"
import style0 from "./QuickStart.vue?vue&type=style&index=0&id=4c55cc4f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c55cc4f",
  null
  
)

export default component.exports